export default __webpack_public_path__ + "static/media/bihada-factory-mission-12.fdb08922.jpg";